import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { fadeInLeft, fadeInRight, staggerContainer, staggerItem, hoverScale, textVariants } from '../../utility/framerAnimations';

const ChooseUsSection = ({ onScrollToForm }) => {
  const { t } = useTranslation('homepage');

  const cardData = [
    {
      title: t('choose-us-section-card-title1'),
      icon: '/images/fast-loan-approvals-icon.png',
    },
    {
      title: t('choose-us-section-card-title2'),
      icon: '/images/wide-vehicle-coverage-icon.png',
    },
    {
      title: t('choose-us-section-card-title3'),
      icon: '/images/easy-online-application-icon.png',
    },
    {
      title: t('choose-us-section-card-title4'),
      icon: '/images/tailored-loan-solutuions-icon.png',
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '40px',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '40px',
        },
      },
    ],
  };

  return (
    <section className="mt-5">
      <Container>
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          style={{ overflow: 'hidden' }}
        >
          <Row className="gy-4"> 
            <Col lg={6} sm={12} className="choose-us-section-left d-flex flex-column">
              <motion.div
                variants={fadeInLeft}
                className="d-flex flex-column"
                style={{ overflow: 'hidden' }}
              >
                <motion.h2 
                  className="choose-us-section-left-content"
                  variants={textVariants}
                >
                  {t('choose-us-section-title')}
                </motion.h2>
                <motion.p
                  variants={textVariants}
                >
                  {t('choose-us-section-description')}
                </motion.p>
                <motion.button 
                  className="btn btn-primary" 
                  onClick={onScrollToForm}
                  variants={hoverScale}
                  whileHover="hover"
                  whileTap={{ scale: 0.96 }}
                >
                  {t('choose-us-section-button')} &#8594;
                </motion.button>
                <motion.img
                  src="/images/airplane-layout.png"
                  alt="aero-image"
                  className="choose-us-section-left-content-img d-none d-lg-block mt-4"
                  variants={textVariants}
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.5 }}
                />
              </motion.div>
            </Col>
          
            <Col lg={6} sm={12} className="ms-lg-auto">
              <motion.div
                variants={fadeInRight}
                className="d-md-none choose-us-slider-container"
                style={{ overflow: 'hidden' }}
              >
                <Slider {...sliderSettings}>
                  {cardData.map((card, index) => (
                    <div key={index} className="p-2">
                      <motion.div
                        variants={staggerItem}
                        whileHover="hover"
                        hoverVariants={hoverScale}
                      >
                        <Card className="h-100 shadow-sm text-center border-0 choose-us-section-right-content-box">
                          <Card.Body className="d-flex flex-column align-items-center">
                            <motion.img
                              src={card.icon}
                              alt={`${card.title} icon`}
                              className="mb-4"
                              style={{ maxWidth: '53px', height: 'auto' }}
                              variants={textVariants}
                              whileHover={{ scale: 1.1, rotate: 5 }}
                              transition={{ duration: 0.3 }}
                            />
                            <motion.div
                              variants={textVariants}
                            >
                              <Card.Title as="h5" className="mb-0 choose-us-section-right-content-box-title">
                                {card.title}
                              </Card.Title>
                            </motion.div>
                          </Card.Body>
                        </Card>
                      </motion.div>
                    </div>
                  ))}
                </Slider>
              </motion.div>

              <motion.div
                variants={staggerContainer}
                className="d-none d-md-flex"
                style={{ overflow: 'hidden' }}
              >
                <Row xs={1} md={2} sm={2} className="g-5">
                  {cardData.map((card, index) => (
                    <Col key={index} className="choose-us-section-right-content-box-wrapper">
                      <motion.div
                        variants={staggerItem}
                        whileHover="hover"
                        hoverVariants={hoverScale}
                        transition={{ delay: index * 0.1 }}
                      >
                        <Card className="h-100 shadow-xs text-center border-0 choose-us-section-right-content-box">
                          <Card.Body className="d-flex flex-column align-items-center">
                            <motion.img
                              src={card.icon}
                              alt={`${card.title} icon`}
                              className="mb-4"
                              style={{ maxWidth: '53px', height: 'auto' }}
                              variants={textVariants}
                              whileHover={{ scale: 1.1, rotate: 5 }}
                              transition={{ duration: 0.3 }}
                            />
                            <motion.div
                              variants={textVariants}
                            >
                              <Card.Title as="h5" className="mb-0 choose-us-section-right-content-box-title">
                                {card.title}
                              </Card.Title>
                            </motion.div>
                          </Card.Body>
                        </Card>
                      </motion.div>
                    </Col>
                  ))}
                </Row>
              </motion.div>
            </Col>
          </Row>
        </motion.div>
      </Container>
    </section>
  );
};

export default ChooseUsSection;